/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {SignalAdminResourcePageState} from '../common/controller/signal-admin-resource-page-state';
import {AppSharedModule} from '../common/app-shared.module';
import {ChartsModule} from '../common/directives/charts.module';
import {StatsTablesModule} from '../common/controller/stats-tables.module';
import {NotesComponent} from '../common/directives/notes/notes.component';

@Component({
  standalone: true,
  imports: [AppSharedModule, ChartsModule, StatsTablesModule, NotesComponent],
  selector: 'adn-external-ad-unit-analysis-page',
  template: `
    <p *ngIf="effectiveIsNew" class="alert alertSimple small">
      This space will be filled with charts once the external ad unit is saved.
    </p>
    <ng-container *ngIf="!effectiveIsNew">
      <div class="analysisWidgetContainer">
        <adn-performance-chart [obj]="model" adnChartType="EXTERNAL_AD_UNIT"></adn-performance-chart>
      </div>

      <div class="topStatsWidgetContainer chartOptions">
        <adn-top-stats-table [object]="model" parentType="ExternalAdUnit" childType="Site"></adn-top-stats-table>
      </div>

      <div class="topStatsWidgetContainer chartOptions">
        <adn-top-stats-table [object]="model" parentType="ExternalAdUnit" childType="AdUnit"></adn-top-stats-table>
      </div>

      <div class="analysisWidgetContainer analysisReportWidgets">
        <adn-notes [object]="model" [saveObject]="notesSaveTarget" [readOnly]="state?.readOnly()"></adn-notes>
      </div>
    </ng-container>
  `
})
export class ExternalAdUnitAnalysisPageComponent implements OnChanges {
  @Input() model: any;
  @Input() isNew: boolean;
  @Input() state: SignalAdminResourcePageState<any>;

  effectiveIsNew = false;
  notesSaveTarget: any;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.isNew) {
      this.effectiveIsNew = !!this.isNew;
    }
    if (changes.model || changes.state) {
      this.notesSaveTarget = this.state ? this.state.notesSaveTarget() : this.model;
    }
  }
}
